import React from 'react';
import './Content.css';

const Content = ({ title, subtitle, text, actionText, fullAddress, phone }) => (
  <div className="content">
    <h4 className="contentSubtitle">{subtitle}</h4>
    <h3 className="contentTitle">{title}</h3>
    <p className="contentText">{text}</p>
    {actionText == "Visit us" &&
      <a href={`https://maps.google.com/?q=${fullAddress}`}>
          <button className="heroAction">{actionText}</button>
      </a>
    }
    {actionText == "Call us today" &&
      <a href={`tel:+${phone}`}>
          <button className="heroAction">{actionText}</button>
      </a>
    }
  </div>
);

export default Content;
